const quizData = [
  {
    id: 1,
    question: 'What are the four components of an aviation Safety Management System (SMS)?',
    options: [
      'Safety Policy, Risk Management, Safety Assurance, Safety Promotion',
      'Planning, Organizing, Leading, Controlling',
      'Hazard Identification, Risk Assessment, Mitigation, Reporting',
      'Compliance, Training, Auditing, Reporting',
    ],
    correctAnswer: 0,
  },
  {
    id: 2,
    question: 'Which organization mandates SMS implementation for aviation service providers?',
    options: ['FAA', 'ICAO', 'IATA', 'EASA'],
    correctAnswer: 1,
  },
  {
    id: 3,
    question: 'What is the primary goal of SMS in aviation?',
    options: [
      'To reduce operational costs',
      'To ensure regulatory compliance',
      'To proactively manage safety risks',
      'To improve customer satisfaction',
    ],
    correctAnswer: 2,
  },
  {
    id: 4,
    question: 'Which SMS component involves continuous monitoring and evaluation of safety performance?',
    options: [
      'Safety Policy',
      'Safety Risk Management',
      'Safety Assurance',
      'Safety Promotion',
    ],
    correctAnswer: 2,
  },
  {
    id: 5,
    question: 'What is a “hazard” in the context of aviation SMS?',
    options: [
      'An accident that has already occurred',
      'A condition or object with the potential to cause harm',
      'A violation of aviation regulations',
      'A type of aircraft malfunction',
    ],
    correctAnswer: 1,
  },
  {
    id: 6,
    question: 'Which of the following is a key element of Safety Promotion?',
    options: [
      'Risk analysis',
      'Safety audits',
      'Training and communication',
      'Incident investigation',
    ],
    correctAnswer: 2,
  },
  {
    id: 7,
    question: 'What is the purpose of a Safety Risk Assessment?',
    options: [
      'To assign blame for incidents',
      'To evaluate the effectiveness of training',
      'To determine the likelihood and severity of risks',
      'To ensure compliance with laws',
    ],
    correctAnswer: 2,
  },
  {
    id: 8,
    question: 'Which document outlines an organization’s commitment to safety?',
    options: [
      'Safety Manual',
      'Safety Policy Statement',
      'Risk Register',
      'Audit Report',
    ],
    correctAnswer: 1,
  },
  {
    id: 9,
    question: 'What is a key benefit of a non-punitive reporting system in SMS?',
    options: [
      'Reduces paperwork',
      'Encourages reporting of safety issues',
      'Improves financial performance',
      'Eliminates all risks',
    ],
    correctAnswer: 1,
  },
  {
    id: 10,
    question: 'Which phase of SMS implementation focuses on integrating SMS into daily operations?',
    options: [
      'Reactive phase',
      'Proactive phase',
      'Predictive phase',
      'Operational phase',
    ],
    correctAnswer: 3,
  },
];
export default quizData;
